module.exports = __webpack_public_path__ + "static/media/area_icon.22d517e9.svg";